"use client"; // Error components must be Client Components

import { useEffect } from "react";
import Link from "next/link";
import { ArrowLeft, AlertTriangle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error("Blog post error:", error);
  }, [error]);

  return (
    <>
      <Navbar />
      <div style={{ minHeight: "60vh", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f9fafb" }}>
        <div style={{ maxWidth: "500px", padding: "40px", backgroundColor: "white", borderRadius: "12px", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)", textAlign: "center" }}>
          <AlertTriangle size={48} color="#ef4444" style={{ margin: "0 auto 16px" }} />
          <h2 style={{ fontSize: "24px", fontWeight: "600", color: "#111827", marginBottom: "12px" }}>Something went wrong!</h2>
          <p style={{ color: "#4b5563", marginBottom: "24px", lineHeight: "1.5" }}>
            We encountered an error while trying to load the blog article. Please try again or go back to the blog listing.
          </p>
          <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
            <button
              onClick={() => reset()}
              style={{ padding: "10px 20px", backgroundColor: "#7c3aed", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "500", transition: "background-color 0.2s" }}
            >
              Try again
            </button>
            <Link href="/blog" style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "10px 20px", backgroundColor: "#f3f4f6", color: "#374151", textDecoration: "none", borderRadius: "6px", fontWeight: "500", transition: "background-color 0.2s" }}>
              <ArrowLeft size={16} /> Back to Blog
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
